import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="lg:w-1/2 relative bg-secondary-100">
        <img
          src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20fashion%20flat%20lay%20with%20folded%20denim%20jeans%20a%20striped%20linen%20shirt%20and%20leather%20accessories%20in%20warm%20terracotta%20and%20cream%20tones%20on%20a%20light%20oak%20surface%2C%20soft%20natural%20sunlight%20from%20left%2C%20minimal%20editorial%20composition%20with%20organic%20fabric%20textures%2C%20harmonious%20neutral%20palette&width=900&height=700&seq=cta-fashion-v2-001&orientation=landscape"
          alt="Kaspreadsheet fashion collection"
          className="w-full h-[350px] md:h-[500px] lg:h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6">
          <span className="text-xs font-label font-medium bg-background-50/90 text-foreground-800 px-3 py-1.5 rounded-full">
            Official Store
          </span>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-12 py-14 md:py-20">
        <div className="max-w-md text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Visit Kaspreadsheet
            <br />
            <span className="text-primary-500">Your Style Awaits</span>
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            Ready to explore the latest fashion trends? Head over to Kaspreadsheet and discover 
            a curated collection of stylish clothing, accessories, and more &mdash; all at unbeatable prices.
          </p>
          <div className="mt-8">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full font-label font-semibold text-sm hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              litbuy spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}